export default __webpack_public_path__ + "static/media/Switch.2a645947.jpg";